<!-- src/components/ui/BaseButton.vue -->
<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to"
    class="base-button"
    :class="[variantClass, $attrs.class]"
    v-bind="$attrs"
    @click="onClick"
  >
    <span v-if="$slots['icon-left']" class="icon icon-left"><slot name="icon-left" /></span>
    <span class="label"><slot /></span>
    <span v-if="$slots['icon-right']" class="icon icon-right"><slot name="icon-right" /></span>
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  emits: ['click'],
  props: {
    to: { type: [String, Object], default: null },
    variant: { type: String, default: 'primary' }
  },
  computed: {
    variantClass() { return `btn--${this.variant}` }
  },
  methods: {
    onClick(event) {
      // ретранслируем нативный event в слушателей родителя
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped>
/* (ваши стили без изменений) */
.base-button{
  display:inline-flex;
  align-items:center;
  gap:10px;
  padding:10px 18px;
  border-radius:20px;
  text-decoration:none;
  border:none;
  cursor:pointer;
  background: var(--hp-button-color, #F6F6F6);
  color: var(--button-text-color, #222222);
  box-shadow: var(--button-shadow, 0 4px 4px rgba(0,0,0,0.2));
  transition: transform .12s ease, background .12s ease;
  font-weight:700;
  white-space:nowrap;
}
.base-button:hover{ transform: translateY(-2px); }

/* icons */
.icon { display:inline-flex; align-items:center; justify-content:center; }
.icon-left{ margin-right:6px }
.icon-right{ margin-left:6px }

/* variants */
.btn--primary { background: var(--hp-button-color, #F6F6F6); color: var(--button-text-color, #222222); }
.btn--ghost { background: transparent; border: 1px solid rgba(255,255,255,0.06); color: var(--button-text-color, #222222); }

/* nav-btn rules */
.base-button.nav-btn {
  height: 44px;
  padding: 8px 18px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.base-button.nav-btn.btn--ghost { background: transparent; border: 1px solid rgba(0,0,0,0.06); color: var(--button-text-color, #222); }
.base-button.nav-btn { color: var(--button-text-color, #222); }
.base-button.nav-btn:hover { transform: translateY(-1px); }
</style>
